export default function PhiRole(p) {
    this.id = p && p.id ? p.id : null;
    this.role_type_id = p && p.role_type_id ? p.role_type_id : null;
    this.role_deleted = p && p.role_deleted ? p.role_deleted : null;
    this.created_time = p && p.created_time ? Date(p.created_time) : null;
    this.modified_time = p && p.modified_time ? Date(p.modified_time) : null;
    return this

}




// WEBPACK FOOTER //
// ./src/Phi/PhiRole.js